import { gql } from '@apollo/client'

export const GET_AGREEMENT_HTML_TEMPLATE = gql`
  query getEquipmentUsageAgreementHTMLTemplate(
    $organizationID: ID!
    $employeeID: ID!
    $userID: ID!
    $copaymentNet: Float!
    $copaymentGross: Float!
    $rentalDuration: ID!
    $deviceDefinitionID: ID!
  ) {
    getEquipmentUsageAgreementHTMLTemplate(
      organizationID: $organizationID
      employeeID: $employeeID
      userID: $userID
      copaymentNet: $copaymentNet
      copaymentGross: $copaymentGross
      rentalDuration: $rentalDuration
      deviceDefinitionID: $deviceDefinitionID
    ) {
      html
    }
  }
`
